import { render, staticRenderFns } from "./ZaIcon.vue?vue&type=template&id=64206bc7&scoped=true"
import script from "./ZaIcon.vue?vue&type=script&lang=ts"
export * from "./ZaIcon.vue?vue&type=script&lang=ts"
import style0 from "./ZaIcon.vue?vue&type=style&index=0&id=64206bc7&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64206bc7",
  null
  
)

export default component.exports